<template>
  <div v-show="show" class="scroll" @click="onClick"/>  
</template>

<script>
import throttle from 'lodash.throttle';

export default {
  data: () => ({
    show: false,
  }),
  methods: {
    onClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
  mounted() {
    window.addEventListener('scroll', throttle(() => {
      this.show = document.documentElement.scrollTop > screen.height;
    }, 300));
  },
}
</script>

<style lang="scss" scoped>
.scroll {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 20px;
  z-index: 50;
  border-radius: 50%;
  transform: rotate(180deg);
  background: #3785ac url('../assets/arrow-white.png') no-repeat center;
  box-shadow: -5px 10px 30px rgba(0, 0, 0, 0.2);
}
</style>